export enum FilterTypes {
  Text = "text",
  Number = "number",
  Date = "date",
  Status = "status",
  Autocomplete = "autocomplete",
}

// set unique value
// values need to more quickly understand what mean option: 1, 2 and etc.
// The last number is 15. PLEASE UPDATE to make it easier to find!!!
export enum OptionTypes {
  AutocompleteHasValue = 1,
  AutocompleteHasNotValue = 2,
  DateIs = 3,
  DateEqualTo = 4,
  DateBefore = 14,
  DateAfter = 15,
  DateBetween = 5,
  NumberEqualTo = 6,
  NumberNotEqual = 7,
  NumberBetween = 8,
  NumberNotBetween = 9,
  StatusAnyOf = 10,
  StatusNoneOf = 11,
  TextContains = 12,
  TextNotContain = 13,
}

export enum BackendOptionType {
  All = "all",
  None = "none",
  Or = "or",
}

// consts
// always add new option type to these arrays
export const AUTOCOMPLETE_TYPES = [
  OptionTypes.AutocompleteHasValue,
  OptionTypes.AutocompleteHasNotValue,
];
export const DATE_TYPES = [
  OptionTypes.DateIs,
  OptionTypes.DateEqualTo,
  OptionTypes.DateBefore,
  OptionTypes.DateAfter,
  OptionTypes.DateBetween,
];
export const NUMBER_TYPES = [
  OptionTypes.NumberEqualTo,
  OptionTypes.NumberNotEqual,
  OptionTypes.NumberBetween,
  OptionTypes.NumberNotBetween,
];
export const STATUS_TYPES = [OptionTypes.StatusAnyOf, OptionTypes.StatusNoneOf];
export const TEXT_TYPES = [
  OptionTypes.TextContains,
  OptionTypes.TextNotContain,
];

export enum DatePeriod {
  Today,
  Yesterday,
  Tomorrow,
}

export enum SortingOptions {
  CreatedAt = "created_at",
  BookingStartDates = "booking_start_dates",
}

export enum SortingDirections {
  Ascending = "asc",
  Descending = "desc",
}
